import React, { Component } from "react";
import { truncateText, apiUrl } from "../util";
import request from "request";
import Tests from "../components/Tests";
import { pollWithRetryPromise } from "../util/pollingPromiseUtil";
class UrlTests extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      loading: true,
    };
  }
  cleanupGetDataPolling = null;
  pollingPromise = null;
  componentDidMount() {
    const { url } = this.props.match.params;
    if (url) {
      this.getData();
    }
  }
  componentWillUnmount() {
    clearInterval(this.interval);
    if (this.cleanupGetDataPolling) {
      this.cleanupGetDataPolling();
    }
  }
  getData = () => {
    const { url } = this.props.match.params;
    const { lookback } = this.state;
    const { pollingPromise, cleanup } = pollWithRetryPromise();
    this.pollingPromise = pollingPromise;
    this.cleanupGetDataPolling = cleanup;
    console.log("Fetching data for screenshots url", {
      url,
      lookback,
    });
    this.pollingPromise({
      url: `${apiUrl}/v1/admin/trigger_polling_data`,
      form: {
        type: "get_screenshot",
        clearCache: true,
        data: JSON.stringify({
          url,
          lookback,
        }),
      },
      retryUrl: `${apiUrl}/v1/admin/get_polling_data`,
      retryForm: {
        type: "get_screenshot",
        data: JSON.stringify({
          url,
          lookback,
        }),
      },
      token: this.props.user.token,
    })
      .then(json => {
        this.setState({
          loading: false,
          items: json.items || [],
          page_types: json.page_types || [],
        });
        if (this.cleanupGetDataPolling) {
          this.cleanupGetDataPolling();
          this.cleanupGetDataPolling = null;
        }
      })
      .catch(err => {
        console.error("Error fetching data:", err);
        this.setState({
          loading: false,
        });
      });
  };

  render() {
    const { zoom, items, loading } = this.state;
    const url = decodeURIComponent(this.props.match.params.url);

    if (loading) {
      return <h1>Loading...</h1>;
    }

    return (
      <div>
        <h1 className={zoom === "out" ? "f3" : "f1"}>
          Tests for <a href={url}>{truncateText(url, 50)}</a>
        </h1>
        {items && items.length !== 0 && (
          <div>
            <h3 className="f3">
              {items.length} {items.length === 1 ? "test" : "tests"} currently
              published or in queues
            </h3>
            <div className="flex flex-wrap"></div>
          </div>
        )}
        <Tests items={items} page_types={this.state.page_types} />
      </div>
    );
  }
}

export default UrlTests;
